import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { registerSW } from "virtual:pwa-register";

// Lazy load Sentry only in production
if (process.env.NODE_ENV === "PROD") {
  import("@sentry/react").then((Sentry) => {
    Sentry.init({
      dsn: "https://fa97ed2fa2b5cbf716c5ea5017151f6e@o4509186048000000.ingest.de.sentry.io/4509186050162768",
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 1.0,
      tracePropagationTargets: ["localhost", "https://web.cirkular.world"],
    });
  });
}

document.title = __APP_TITLE__;

// Handle service worker migration for both PROD and STAGE
if (
  "serviceWorker" in navigator &&
  (process.env.NODE_ENV === "PROD" || process.env.NODE_ENV === "STAGE")
) {
  window.addEventListener("load", async () => {
    try {
      // Check for existing service worker registrations
      const registrations = await navigator.serviceWorker.getRegistrations();

      // Look for any old service worker that needs migration
      const oldSwRegistration = registrations.find(
        (reg) =>
          reg.active &&
          (reg.active.scriptURL.includes("pwa-sw.js") ||
            (reg.active.scriptURL.includes("sw.js") &&
              !reg.active.scriptURL.includes("workbox"))),
      );

      if (oldSwRegistration) {
        console.log("Found old service worker, migrating to new sw.js...");

        // Unregister the old service worker
        await oldSwRegistration.unregister();

        // Clear all caches
        const cacheNames = await caches.keys();
        for (const cacheName of cacheNames) {
          await caches.delete(cacheName);
          console.log("Deleted cache:", cacheName);
        }

        // Force reload to get the new service worker
        window.location.reload();
      }
    } catch (error) {
      console.error("Service worker migration failed:", error);
    }
  });
}

registerSW({ immediate: true });

createRoot(document.getElementById("root")!).render(<App />);
